module.exports = __webpack_public_path__ + "assets_app/img/key-0.bf32f3fe.svg";